import React, { type ReactNode } from 'react'
import { Button } from '@mc/design-system'
import { EnhancedCtaCopy } from '@mc/growth'
import { GiftButton } from '../../../../components/GiftButton'
import { LOCATION } from '../../../../lib/events'
import { GIFT_CTA_HREF } from '../../constants'
import styles from './BannerCtaWrapper.module.scss'

interface BannerCtaWrapperProps {
  isVariant: boolean
  control: ReactNode
  ctaHref: string
  ctaCopy: string
  onCtaClick: () => void
  onGiftClick: () => void
}

export const BannerCtaWrapper = ({
  isVariant,
  control,
  ctaHref,
  ctaCopy,
  onCtaClick,
  onGiftClick,
}: BannerCtaWrapperProps) => {
  if (!isVariant) return <>{control}</>

  return (
    <>
      {/* Tablet & Desktop */}
      <div className='d-none d-md-flex align-items-center mc-gap-2'>
        <GiftButton
          size='sm'
          location={LOCATION}
          href={GIFT_CTA_HREF}
          onClick={onGiftClick}
        />
        <Button render={<a href={ctaHref} />} onClick={onCtaClick} size='sm'>
          <EnhancedCtaCopy size='sm'>{ctaCopy}</EnhancedCtaCopy>
        </Button>
      </div>

      {/* Mobile */}
      <div className={`d-md-none mc-gap-2 mc-mt-3 ${styles.mobilePair}`}>
        <GiftButton
          size='sm'
          fullWidth
          className='mc-py-2'
          location={LOCATION}
          href={GIFT_CTA_HREF}
          onClick={onGiftClick}
        />
        <Button
          render={<a href={ctaHref} />}
          onClick={onCtaClick}
          size='sm'
          fullWidth
          className='mc-py-2'
        >
          <EnhancedCtaCopy size='sm'>{ctaCopy}</EnhancedCtaCopy>
        </Button>
      </div>
    </>
  )
}
